module.exports = __webpack_public_path__ + "img/close.3e560ba0.svg";